// AI assistant chat (Polza) — entry: init view + composer wiring
import { aiChatMessagesEl, aiChatInputEl, aiChatSendBtn } from './dom.js';
import { bumpAiChatInitSeq, getAiChatInitSeq, setAiChatHistory } from './session.js';
import { scrollAiChatToBottom } from './scroll.js';
import { cancelAiChatTextStream } from './stream.js';
import {
  clearAiChatMessagesDom,
  loadAiChatHistoryFromServer,
  aiChatHasWelcomeBubble,
  appendAiChatBubble
} from './messages.js';
import { sendAiChatMessage } from './send.js';
import type { AiChatMessage } from '../../types/api.js';

const AI_WELCOME_TEXT =
  'Здравствуйте! Помогу с подбором ПК, апгрейдом и готовыми сборками Deep Design PC. Напишите задачу и бюджет.';

function showAiWelcomeBubble(): void {
  const welcomeRow = appendAiChatBubble('assistant', AI_WELCOME_TEXT, {
    incoming: true,
    fadeOnly: true,
    streamText: true
  });
  if (welcomeRow) welcomeRow.setAttribute('data-ai-welcome', '1');
}

export function initAiAssistantView(): void {
  if (!aiChatMessagesEl) return;
  const loadSeq = bumpAiChatInitSeq();
  cancelAiChatTextStream();
  setAiChatHistory([]);
  clearAiChatMessagesDom();

  loadAiChatHistoryFromServer()
    .then(function (messages) {
      if (loadSeq !== getAiChatInitSeq()) return;
      const history = messages
        .map(function (m: AiChatMessage) {
          if (!m || (m.role !== 'user' && m.role !== 'assistant')) return null;
          const content = String(m.content || '').trim();
          if (!content) return null;
          return { role: m.role, content: content };
        })
        .filter((m): m is AiChatMessage => m !== null);

      setAiChatHistory(history);

      if (history.length) {
        for (let i = 0; i < history.length; i++) {
          const msg = history[i];
          appendAiChatBubble(msg.role === 'user' ? 'user' : 'assistant', msg.content, {
            animate: false,
            instantScroll: true,
            streamText: false
          });
        }
      } else if (!aiChatHasWelcomeBubble()) {
        showAiWelcomeBubble();
      }

      scrollAiChatToBottom();
      if (aiChatInputEl) {
        try {
          aiChatInputEl.focus();
        } catch (_) {}
      }
    })
    .catch(function () {
      if (loadSeq !== getAiChatInitSeq()) return;
      if (!aiChatHasWelcomeBubble()) showAiWelcomeBubble();
      scrollAiChatToBottom();
    });
}

if (aiChatSendBtn) {
  aiChatSendBtn.addEventListener('click', function () {
    sendAiChatMessage();
  });
}

if (aiChatInputEl) {
  aiChatInputEl.addEventListener('keydown', function (ev) {
    if (ev.key === 'Enter' && !ev.shiftKey) {
      ev.preventDefault();
      sendAiChatMessage();
    }
  });
}
